const DEFAULT_API_URL = 'http://127.0.0.1:8000';

export function normalizeApiBaseUrl(url) {
  if (!url || typeof url !== 'string') {
    return DEFAULT_API_URL;
  }
  const trimmed = url.trim().replace(/\/+$/, '');
  return trimmed || DEFAULT_API_URL;
}

const config = {
  apiBaseUrl: normalizeApiBaseUrl(process.env.REACT_APP_API_URL),
  secretKey: process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PRODUCTION_SECRET_KEY
    : process.env.REACT_APP_DEVELOPMENT_SECRET_KEY,
  initializationVector: process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PRODUCTION_IV
    : process.env.REACT_APP_DEVELOPMENT_IV,
};

export default config;
